/**
 * XIconOffset
 */
class XIconOffset {

  /**
   * XIconOffset
   * @param x
   * @param y
   */
  constructor({ x = 0, y = 0 } = {}) {
    this.x = x;
    this.y = y;
  }

}

export {
  XIconOffset,
};
